/*
 * An adapter for NgbTime to transform the model
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import {
  NgbTimeAdapter,
  NgbTimeStruct
} from '@ng-bootstrap/ng-bootstrap';

const pad = (i: number): string => i < 10 ? `0${ i }` : `${ i }`;

@Injectable()
export class NgbTimeStringAdapter extends NgbTimeAdapter<string> {
  fromModel(value: string | null): NgbTimeStruct | null {
    if (!value) {
      return null;
    }
    const [ hourStr, minuteStr, partOfDay ] = value.split(/[: ]/);
    let hour;
    const minute = parseInt(minuteStr, 10);
    if (partOfDay === 'AM') {
      if (hourStr === '12') {
        hour = 0;
      } else {
        hour = parseInt(hourStr, 10);
      }
    } else {
      hour = parseInt(hourStr, 10) + 12;
    }
    return {
      hour,
      minute,
      second: 0
    };
  }

  toModel(time: NgbTimeStruct | null): string | null {
    if (time === null) {
      return undefined;
    }
    const partOfDay = time.hour >= 12 ? 'PM' : 'AM';
    const hour = time.hour === 0 ? 12 : time.hour > 12 ? `${ time.hour - 12 }`.padStart(2, '0') : `${ time.hour }`.padStart(2, '0');
    const minute = `${ time.minute }`.padStart(2, '0');
    return `${ hour }:${ minute } ${ partOfDay }`;
  }
}
